function createFunctionWithTimeout(callback, opt_timeout) {
  var called = false;
  setTimeout(callback, opt_timeout || 1000);
  return function() {
    if (!called) {
      called = true;
      callback();
    }
  }
}

$(".navbar-collapse").css({ maxHeight: $(window).height() - $(".navbar-header").height() + "px" });

$(".show-text").click(function(){
    $(this).next('div').show();
    $(this).text($(this).text().replace('Expand', ''));
});
$(".subnav li a").click(function(ev){
    ev.stopPropagation();
    // var clicked = $(ev.delegateTarget).find("a");
    var dest = $(this).attr("href");
    if(dest.substr(0,1) == "#"){
        ev.preventDefault;
        $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top-$(".navbar-header").height() }, 500);
    }
    $(this).parent('li').siblings().find('a').removeClass('active');
    $(this).addClass('active');
});
$(".scroll-to-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "medium");
    return false;
});
$(".go2top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "medium");
    return false;
});

var timer = 0;
$('.nav-link.dropdown-toggle').click(function(){
    if(timer == 0){
        timer = 1;
        timer = setTimeout(function(){timer = 0;}, 300);
    }else{
        var pointer = $(this).attr("href");
        window.location.href = pointer;
    }
 });

$(window).resize(function(){
    $('.homepage .carousel-container').css('maxHeight', $(window).height());
});

$(window).on('load',function(){
    var footerOffset = $('.footer').offset().top;
    var windowHeight = $(window).height();
    var footerHeight = $('.footer').height();
    if (footerOffset < windowHeight - footerHeight) {
        $('.footer').css('bottom', 0);
    }

    $('.homepage .carousel-container').css('maxHeight', $(window).height());
});

var lastScrollTop = 0;

jQuery(function () {

    $("select").each(function(i,e) {
        $(e).selectmenu({select:function(ev,ui){ $(ev.target).change(); }}).selectmenu("menuWidget").addClass("selectbox");
    });

    $("input[type='number']").niceNumber({
        autoSize:false
    });



    var menu = $('.subnav-container');

    function navscroll() {
        var scrollTop = $(window).scrollTop();
        var subnavOffsetTop = $('.subnav-container').offset().top;
        var topNavbarHeight = $('#ar-top-navbar').height() + 1; // the 1 accounts for the border bottom of 1px
        var navbarHeight = $('#main-navbar').height();
        var buttonNavHeight = $('.opportunities-nav').height();
        if (buttonNavHeight == null) {
            buttonNavHeight = 0;
            var bannerHeight = $('.banner').height();
            if (bannerHeight == null) {
                bannerHeight = 0;
            } else {
                navbarHeight = bannerHeight - parseInt($('.content').css('padding-top'));
            }
        }
        var parentHeight = $('.subnav-container').parent().height();
        var subnavContainerHeight = $('.subnav-container').height();
        var windowHeight = $(window).height() - navbarHeight;
        var subnavHeightBottom = subnavContainerHeight - windowHeight;

        if(subnavContainerHeight > windowHeight){
            if (scrollTop > lastScrollTop){
                if (scrollTop >= (buttonNavHeight + subnavHeightBottom)) {
                    var subnavTop = scrollTop - buttonNavHeight - subnavHeightBottom - navbarHeight;
                    if(subnavTop <= (parentHeight - subnavContainerHeight) && scrollTop + navbarHeight >= subnavOffsetTop + subnavHeightBottom + 50){
                        $('.subnav-container').css({"top":subnavTop+"px"});
                    }
                }
            } else {
                if (scrollTop >= buttonNavHeight) {
                    var subnavTop = scrollTop - buttonNavHeight;
                    if(subnavTop <= (parentHeight - subnavContainerHeight) && scrollTop + navbarHeight <= subnavOffsetTop){
                        $('.subnav-container').css({"top":subnavTop+"px"});
                    }
                }
            }
            lastScrollTop = scrollTop;
        } else {
            if (scrollTop >= buttonNavHeight) {
                var subnavTop = scrollTop - buttonNavHeight;
                if(subnavTop <= (parentHeight - subnavContainerHeight)){
                    $('.subnav-container').css({"top":subnavTop+"px"});
                }
            }
        }
    }
    if(menu.length !== 0){
        document.onscroll = navscroll;
        $('.subnav-container ul li a').click(function (e) {
            console.log('hello');
            var href = $(this).attr('href');
            if(href.substring(0,1) == "#"){
                if($('.scrolling_subnav').length != 0){
                    e.preventDefault();
                }
                $('.subnav-header').click();
                $('html,body').animate({
                    scrollTop: $($(this).attr('href')).offset().top-80
                }, 500);
            }
            else {
                window.location.href = href;
            };

        }); // this function is to make the transitions between links smooth
    }

    $('.subnav-header').click(function(){
        if ($(this).parent().hasClass('in')){
            $(this).parent().removeClass('in');
            $('.subnav-overlay').remove();
        }else{
            $(this).parent().addClass('in');
            $('.content').append('<div class="subnav-overlay"></div>');
        }
    });

    $(".panel-heading").click(function(){
        $(".panel").each(function(){
            $(this).find('a').find('span').removeClass('glyphicon glyphicon-chevron-up');
            $(this).find('a').find('span').addClass('glyphicon glyphicon-chevron-down');
        })
        if($(this).find('a').hasClass('collapsed')){
            $(this).find('a').find('span').removeClass('glyphicon glyphicon-chevron-down');
            $(this).find('a').find('span').addClass('glyphicon glyphicon-chevron-up');
        }
    });

    $("#register-form").validate({
        ignore: [],
        rules: {
            email: {
                required: true,
                email: true
            },
            username: {
                required: true,
                minlength: 4
            },
            password: {
                required: true,
                minlength: 6,
                maxlength: 16
            },
            password_confirmation: {
                required: true,
                minlength: 6,
                equalTo: "#password"
            },
            terms_conditions_checkbox:{
                required: true
            },
            privacy_policy_checkbox: {
                required: true
            }
        },
        messages: {
            email: {
                required: "Please enter a your email address",
                email: "Please enter a valid email address in the format of name@domain.com"
            },
            username: {
                required: "Please enter a valid username",
                minlength: "Your username must be at least 4 characters long"
            },
            password: {
                required: "Please enter a valid password",
                minlength: "Your password must be at least 6 characters long",
                maxlength: "your password cannot be more then 16 characters long"
            },
            password_confirmation: {
                required: "Please confirm your password",
                equalTo: "Your passwords do not match",
                minlength: "Your password must be at least 6 characters long"
            },
            terms_conditions_checkbox: {
                required: "Please agree to our Terms and Conditions"
            },
            privacy_policy_checkbox: {
                required: "Please accept our Privacy Policy"
            }
        },
        highlight: function(element) {
            $(element).parent('div').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).parent('div').removeClass('has-error');
        },
        success: function(element) {
            $(element).parent('div').addClass('has-success');
            $(element).remove();
        }
    });

    $('#login-form').validate({
        rules: {
            username: {
                required: true,
                minlength: 4
            },
            password: {
                required: true,
                minlength: 6
            }
        },
        messages: {
            username: {
                required: "Please enter your User Name",
                minlength: "Please enter a valid User Name"
            },
            password: {
                required: "Please enter your Password",
                minlength: "Please enter a valid Password"
            }
        },
        highlight: function(element) {
            $(element).parent('div').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).parent('div').removeClass('has-error');
        },
        success: function(element) {
            $(element).parent('div').addClass('has-success');
            $(element).remove();
        }
    });

    $('#companyCreate').validate({
        ignore: [],
        rules: {
            companyName: {
                required: true,
                minlength: 2
            },
            username: {
                required: true,
                minlength: 2
            },
            address1: {
                required: true
            },
            address2: {
                required: false
            },
            city: {
                required: true
            },
            state: {
                required: true
            },
            postalCode: {
                required: true
            },
            phone: {
                required: true
            },
            contactEmail: {
                required: true,
                email: true
            },
            terms_conditions_checkbox:{
                required: true
            }
        },
        messages: {
            companyName: {
                required: "Please enter your Company Name",
                minlength: "Your Company Name must be 2 characters or more."
            },
            username: {
                required: "Please enter your userame. if you have not created a user account, click on the link at the bottom of the form.",
                minlength: "Your userame must be 2 characters or more."
            },
            address1: {
                required: "Please enter your company address."
            },
            city: {
                required: "Please enter the city your company is located in."
            },
            state: {
                required: "Please enter the state your company is located in."
            },
            postalCode: {
                required: "Please enter the zipcode your company is located in."
            },
            phone: {
                required: "Please enter your company phone number."
            },
            contactEmail: {
                required: "Please enter your company contact email.",
                email: "Please enter a valid email address."
            },
            terms_conditions_checkbox: {
                required: "Please agree to our Terms and Conditions"
            }
        },
        highlight: function(element) {
            $(element).parent('div').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).parent('div').removeClass('has-error');
        },
        success: function(element) {
            $(element).parent('div').addClass('has-success');
            $(element).remove();
        }
    });

    $('#enterpriseAccount').validate({
        ignore: [],
        rules: {
            terms_conditions_checkbox: {
                required: true
            }
        },
        messages: {
            terms_conditions_checkbox: {
                required: "Please agree to our Terms and Conditions"
            }
        },
        highlight: function(element) {
            $(element).parent('div').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).parent('div').removeClass('has-error');
        },
        success: function(element) {
            $(element).parent('div').addClass('has-success');
            $(element).remove();
        }
    });

    // $.fn.wobbleMe = function(options) {
    //     var defaults = {
    //         maxX: 10,
    //         maxY: 5
    //     };
    //     // This makes it so the users custom options overrides the default ones
    //     var settings = $.extend({}, defaults, options);
    //     return this.each(function() {
    //         var obj = $(this).find("img");
    //         moveIt(obj,settings.maxX,settings.maxY);
    //         return this;
    //     }); // END: return this
    //     // returns the jQuery object to allow for chainability.
    // };

    // function moveIt(obj,maxX,maxY){
    //     var newX = Math.floor(Math.random() * maxX);
    //     var newY = Math.floor(Math.random() * maxY);
    //     $(obj).animate({"top":newY+"px","left":newX+"px"},{duration: 1000,easing:"linear",complete:function(){moveIt(obj,maxX,maxY);}});
    // };
});
